export default {
  name: 'CustomFieldMixin',
  props: {
    label: String,
    hint: String,
    placeholder: String,
    value: [String, Number],
    default: [String, Number],
    fieldClass: { type: String, default: '' },
    errors: { type: Array, default: () => [] },
    dense: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    setValue(v) {
      this.$emit('input', v)
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(v) {
        this.setValue(v)
      }
    }
  },
  created() {
    if (!!this.default) {
      this.setValue(this.default)
    }
  }
}
